import { ChargeDetail } from "@/types/charge";

import { ENROLLMENT_MEMBER_META_KEY } from "./charge-meta-keys";
import { removeEnrollment } from "@/api/provider/inventory/member";

// Staff took a membership off the ticket after saving its enrollment for the
// sign-up form. Remove that waiting enrollment too, or it sits on the
// patient's chart as a membership nobody sold. Never once money has moved: a
// paid enrollment can still be waiting on its payment to settle, and removing
// it then would leave the patient charged and not enrolled.
export function releaseSavedEnrollment(charge: ChargeDetail): void {
  const memberId = charge.meta?.[ENROLLMENT_MEMBER_META_KEY];
  if (typeof memberId !== "string") return;
  if ((charge.payments ?? []).length > 0) return;
  void removeEnrollment({
    memberId,
    comment: "Removed from checkout before payment",
  });
}
